import { InstallationStatusDto } from '../api/dto/installation-status.dto'
import { InstallationStatusModel } from '../types'
import { summarizeDeviceLinks } from '../utils/installation-status-transformers'

const installationStatusToModelTransformer = (dto: InstallationStatusDto[]): InstallationStatusModel[] => {
  return dto.map(item => ({
    installationId: item.installationId,
    installationStatus: item.status,
    deviceLinksStatus: summarizeDeviceLinks(item.deviceLinks),
  }))
}

export default installationStatusToModelTransformer
